export default __webpack_public_path__ + "static/media/group.0a8ffd77.svg";